import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const UNLINKED_MNCMS_COUNT_QUERY_KEY = "mncmsUnlinkedCount";

/**
 * Count behind the needs-attention badge. Carries no PHI, so it is cheap to poll —
 * but a maternity message arriving is not a fast-moving event, hence a minute rather
 * than the ten seconds the chat widget uses.
 */
const REFETCH_INTERVAL_MS = 60000;

export const useUnlinkedMncmsCount = ({ enabled = true } = {}) => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    queryKey: [UNLINKED_MNCMS_COUNT_QUERY_KEY, tenantVal],
    queryFn: async () => {
      const axios = createAxiosInstance();
      const response = await axios.get(
        `${tenantVal}/mncms/inbound-messages/unlinked/count`
      );

      // The envelope isn't reliably present by the time this lands — the axios
      // layer unwraps `data` for some responses — so read the count from
      // whichever level actually carries it.
      const payload = response.data?.data ?? response.data;

      return payload?.count ?? 0;
    },
    enabled: enabled && !!tenantVal,
    refetchInterval: REFETCH_INTERVAL_MS,
    refetchOnWindowFocus: true,
  });
};
